var sliders = {
    selectors: {
        phone: '[data-slick-phone]',
        buttons: '.features__content__buttons',
    },

    init: function() {
        var self  = this,
        $slider = $( self.selectors.phone ),
        $buttons = $( self.selectors.buttons ).children(),
        $slide = 0,
        $page = 0;

        var rtl = document.documentElement.getAttribute('dir') === 'rtl' ? true : false;

        $slider.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: true,
            autoplay: true,
            arrows: false,
            autoplaySpeed: 6000,
            rtl: rtl
        });

        $slider.slick('slickPause');
        $slider.eq(0).slick('slickPlay');

        $(".features__content.active").find($buttons).eq($slide).addClass('features__content__button--active')

        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            $slide = nextSlide;
            $(".features__content.active").find($buttons).removeClass('features__content__button--active')
            $(".features__content.active").find($buttons).eq($slide).addClass('features__content__button--active')
        });
        
        $buttons.on('click', function (e) {
            e.preventDefault();
            var index = $(this).index();
            if ( !$(this).hasClass('features__content__button--active') ) {
                $slider.slick('slickGoTo', index); 
            }
        });
        
        // Switch to first slide when opening section
        $(".features__button").on('click', function (e) {
            e.preventDefault();
            var index = $(this).index();
            if ( !$(this).hasClass('active') ) {
                $page = index;
                goToFirst(index);
            }
        });

        $('select').on('change', function() {
            var $newSelected = $(this).parent().parent().find('.selectric-items .selected').data('index');
            if( $page != $newSelected ) {
                $page = $newSelected;
                goToFirst($page);
            }
        });

        // Go to first slide
        function goToFirst(index) {
            setTimeout(() => {
                $slider.slick('slickPause');
                $slider.eq(index).slick('slickGoTo', 0);
                $(".features__content__button--active").removeClass('features__content__button--active');
                $(".features__content").eq(index).find($buttons).eq(0).addClass('features__content__button--active');
                setTimeout(() => { $slider.eq(index).slick('slickPlay'); }, 200);
            }, 1);
        }
    }
}
  
export { sliders };